<template>
  <v-app>
    <v-app-bar app dense>
      <v-toolbar-title>The Cornerstone</v-toolbar-title>
      <v-spacer></v-spacer>
      <span v-if="user" class="hidden-sm-and-down">Welcome, {{user.firstName}}!</span>
      <sign-out class="app-bar-action" v-if="authenticationStatus === 'Authenticated'" @signedOut="signedOut"></sign-out>
    </v-app-bar>

    <v-main class="pt-2">
      <v-container fluid class="pt-2">
        <sign-in v-if="authenticationStatus === 'Unauthenticated'" @signedIn="signedIn"></sign-in>
        <search-users v-if="permissions.allowViewingOfAnyUser" :changePassword="changePassword" :changeUsername="changeUsername" :permissions="permissions"></search-users>
        <v-footer class="pa-3 justify-centerx" app><v-spacer></v-spacer><div class="caption">{{version}}</div><v-spacer class="hidden-md-and-up"></v-spacer></v-footer>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import SignIn from '@/components/authorization/SignIn.vue';
import SignOut from '@/components/authorization/SignOut.vue';
import SearchUsers from '@/components/user/SearchUsers.vue';
import userService from '@/services/User';
import authenticationService from '@/services/Authentication';
import packageInfo from '@/../package.json';

const noPermissions = { undefinedPermission: false };
const noConfigurationData = {};

@Component({
  components: {
    SignIn,
    SignOut,
    SearchUsers,
  },
})
export default class MainApp extends Vue {
  authenticationStatus = 'Unknown';
  user = null;
  permissions = noPermissions;
  version = `V${packageInfo.version}`;

  async autoAuthenticate() {
    if (await authenticationService.autoAuthenticate()) {
      this.signedIn();
    } else {
      this.signedOut();
    }
  }

  signedIn() {
    this.authenticationStatus = 'Authenticated';
    userService.getCurrent().then((user) => {
      this.user = user;

      // I'd prefer this below like it was before, but after major updates
      // the 2nd call typically fails. I do not have time to debug now, so
      // we'll leave as is for now until a proper fix can be found.
      userService.getCurrentPermissions().then((permissions) => {
        this.permissions = permissions;
      });
      userService.getCurrentConfigurationData().then((configurationData) => {
        Vue.prototype.$configurationData = configurationData;
      });
    });
    // userService.getCurrentPermissions().then((permissions) => {
    //   this.permissions = permissions;
    // });
  }

  signedOut() {
    this.authenticationStatus = 'Unauthenticated';
    this.user = null;
    this.permissions = noPermissions;
    Vue.prototype.$configurationData = noConfigurationData;
  }

  changePassword(userBeingChanged, newPassword) {
    return userService.updatePassword(userBeingChanged, newPassword).then(() => {
      if (this.user.id === userBeingChanged.id) {
        authenticationService.replaceCredentials(userBeingChanged.username, newPassword);
      }
    });
  }

  changeUsername(userBeingChanged, newUsername) {
    return userService.updateUsername(userBeingChanged, newUsername);
  }

  mounted() {
    this.autoAuthenticate();
  }
}
</script>

<style scoped>
  .app-bar-action {
    color: black;
    font-size: .65rem;
  }
</style>
<style>
  .v-app-bar {
    background-color: #dbb77a !important;
  }
  .v-card__title {
    background-color: #c29445;
  }
  .v-btn--contained {
      background-color: #dbb77a !important;
  }
  .v-snack__wrapper {
    background-color: #c29445 !important;
  }
  .v-tooltip__content {
    background-color: #dbb77a;
    color: #000000;
  }
</style>
